import { OfficeAddress } from '../models/visitsInvestorModel';

interface Props {
  office: OfficeAddress;
}

const OfficeAddressInfo = ({ office }: Props) => (
  <small className="text-muted d-block mt-2">
    <i className="fa-solid fa-location-dot mr-1"></i>
    {office.address}
    {office.reference && ` (${office.reference})`}
    {office.maps_url && (
      <>
        {' - '}
        <a href={office.maps_url} target="_blank" rel="noreferrer">
          Ver en mapa
        </a>
      </>
    )}
  </small>
);

export default OfficeAddressInfo;
